<template>
    <div>
        <div class="container" style="width:100%;">
            <el-form v-if="isDo" :model="doForm" inline >
                <el-row  type="flex" style="margin-top:0px;" align="center">
                    <el-form-item label="计划编号">
                        {{planItem.id}}
                    </el-form-item>
                    <el-form-item style="margin-left:20px;" label="任务主题">
                        {{planItem.topic}}
                    </el-form-item>
                </el-row>
                <div style="border:1px solid rgb(240 233 233);">
                    <div style="margin-left:5px;">
                        <div class="order-detail">
                            <!-- <el-row  type="flex" style="margin-top:0px;" align="center"> -->
                            <el-form-item label="订单编号">
                                {{planItem.订单编号}}
                            </el-form-item>
                            <el-form-item label="订单日期">
                                {{planItem.订单日期}}
                            </el-form-item>
                            <!-- </el-row> -->
                            <el-form-item label="经销商全称">
                                {{planItem.经销商全称}}
                            </el-form-item>
                            <el-form-item label="CMR">
                                {{planItem.CMR}}
                            </el-form-item>
                            <el-form-item label="原厂帐号">
                                {{planItem.原厂帐号}}
                            </el-form-item>
                            <el-form-item label="终端客户">
                                {{planItem.终端客户}}
                            </el-form-item>
                            <el-form-item label="终端客户联络人">
                                {{planItem.终端客户联络人}}
                            </el-form-item>
                            <el-form-item label="终端客户联络电话">
                                {{planItem.终端客户联络电话}}
                            </el-form-item>
                            <el-form-item label="终端客户电子邮件">
                                {{planItem.终端客户电子邮件}}
                            </el-form-item>
                            <el-form-item v-if="planItem.selfDefine" label="终端客户自定义信息">
                                <span  style="color:red;">{{planItem.selfDefine}}</span>
                            </el-form-item>
                            <el-form-item label="产品名称">
                                {{planItem.产品名称}}
                            </el-form-item>
                            <el-form-item label="数量">
                                {{planItem.数量}}
                            </el-form-item>
                            <el-form-item label="合约周期-开始">
                                {{planItem["合约周期-开始"]}}
                            </el-form-item>
                            <el-form-item label="合约周期-结束">
                                {{planItem["合约周期-结束"]}}
                            </el-form-item>
                            <el-form-item label="订单状态">
                                {{planItem["订单状态"]}}
                            </el-form-item>
                            <el-form-item label="预约开通日">
                                {{planItem["预约开通日"]}}
                            </el-form-item>
                            <el-form-item label="预约关闭日">
                                {{planItem["预约关闭日"]}}
                            </el-form-item>
                            <span style="color:#A9E4FF;cursor:pointer;" @click="planItem.hideDetail=!planItem.hideDetail">展开/收起</span>
                        </div>
                        <div class="order-detail" v-if="!planItem.hideDetail">
                            <el-form-item label="采购单号">
                                {{planItem.采购单号}}
                            </el-form-item>
                            <el-form-item label="分公司">
                                {{planItem.分公司}}
                            </el-form-item>
                            <el-form-item label="经销商代码">
                                {{planItem.经销商代码}}
                            </el-form-item>
                            <el-form-item label="经销商简称">
                                {{planItem.经销商简称}}
                            </el-form-item>
                            <el-form-item label="经销商联络人">
                                {{planItem.经销商联络人}}
                            </el-form-item>
                            <el-form-item label="经销商联络电话">
                                {{planItem.经销商联络电话}}
                            </el-form-item>
                            <el-form-item label="经销商电子邮件">
                                {{planItem.经销商电子邮件}}
                            </el-form-item>
                            <el-form-item label="MPN ID">
                                {{planItem.MPNID}}
                            </el-form-item>
                            <el-form-item label="MicrosoftID">
                                {{planItem.MicrosoftID}}
                            </el-form-item>
                            <el-form-item label="终端客户省份">
                                {{planItem.终端客户省份}}
                            </el-form-item>
                            <el-form-item label="终端客户地区">
                                {{planItem.终端客户地区}}
                            </el-form-item>
                            <el-form-item label="终端客户地址">
                                {{planItem.终端客户地址}}
                            </el-form-item>
                            <el-form-item label="销售总价（未税）">
                                {{planItem["销售总价（未税）"]}}
                            </el-form-item>
                            <el-form-item label="促销总价（未税）">
                                {{planItem["促销总价（未税）"]}}
                            </el-form-item>
                            <el-form-item label="税额">
                                {{planItem.税额}}
                            </el-form-item>
                            <el-form-item label="合计金额（含税）">
                                {{planItem["合计金额（含税）"]}}
                            </el-form-item>
                            <el-form-item label="订单项次">
                                {{planItem.订单项次}}
                            </el-form-item>
                            <el-form-item label="产品类型">
                                {{planItem.产品类型}}
                            </el-form-item>
                            <el-form-item label="厂牌">
                                {{planItem.厂牌}}
                            </el-form-item>
                            <el-form-item label="料号">
                                {{planItem.料号}}
                            </el-form-item>
                            <el-form-item label="原厂料号">
                                {{planItem.原厂料号}}
                            </el-form-item>
                            <el-form-item label="帐单类型">
                                {{planItem.帐单类型}}
                            </el-form-item>
                            <el-form-item label="原厂订阅编号">
                                {{planItem.原厂订阅编号}}
                            </el-form-item>
                            <el-form-item label="媒体单价">
                                {{planItem.媒体单价}}
                            </el-form-item>
                            <el-form-item label="销售单价（未税）">
                                {{planItem["销售单价（未税）"]}}
                            </el-form-item>
                            <el-form-item label="折扣金额">
                                {{planItem.折扣金额}}
                            </el-form-item>
                            <el-form-item label="小计">
                                {{planItem.小计}}
                            </el-form-item>
                            <el-form-item label="备注">
                                {{planItem.备注}}
                            </el-form-item>
                            <el-form-item label="促销说明">
                                {{planItem.促销说明}}
                            </el-form-item>
                            <el-form-item label="续约单号/项次">
                                {{planItem["续约单号/项次"]}}
                            </el-form-item>
                            <el-form-item label="技术服务支持">
                                {{planItem.技术服务支持}}
                            </el-form-item>
                            <el-form-item label="特约优惠">
                                {{planItem.特约优惠}}
                            </el-form-item>
                            <el-form-item label="订阅时长（月）">
                                {{planItem["订阅时长（月）"]}}
                            </el-form-item>
                            <el-form-item label="建立者名称">
                                {{planItem["建立者名称"]}}
                            </el-form-item>
                            <el-form-item label="建立者帐号">
                                {{planItem["建立者帐号"]}}
                            </el-form-item>
                            <el-form-item label="异动者名称">
                                {{planItem.异动者名称}}
                            </el-form-item>
                            <el-form-item label="异动者帐号">
                                {{planItem.异动者帐号}}
                            </el-form-item>
                        </div>
                    </div>
                </div>
                

                
                <el-divider content-position="left" style="margin-top:0px;"><span style="font-size:larger;"></span></el-divider>

                <el-row>
                    <el-form-item label="服务时间">
                        <el-date-picker
                            v-model="doForm.dealDate"
                            type="datetime"
                            placeholder="选择服务时间">
                        </el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="服务内容">
                        <el-input v-model="doForm.content" size="medium" :rows="4" type="textarea"
                            autocomplete="off" placeholder="请填写服务内容" style="width:800px"
                            ></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="服务结论">
                        <el-input v-model="doForm.result" size="medium" :rows="4" type="textarea"
                            autocomplete="off" placeholder="请填写服务结论" style="width:800px"
                            ></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="服务提供方式">
                        <el-select v-model="doForm.provideTypeArr" filterable multiple style="width:300px" placeholder="请选择">
                            <el-option v-for="item in provideList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <my-upload-file-form-item v-model="doForm.sampleArr" label="附件" :limit="10" />
                </el-row>
                <!-- <el-row>
                    <my-upload-file-form-item v-model="doForm.sampleArr" label="附件" :limit="10" />
                </el-row>   -->
                <el-row>
                    <el-form-item label="内部说明">
                        <el-input v-model="doForm.innerRemark" size="medium" :rows="4" type="textarea"
                            autocomplete="off" placeholder="" style="width:800px"
                            ></el-input>
                    </el-form-item>
                </el-row>                
            </el-form>      
            <div  v-if="isDo" style="display:flex;justify-content:center;margin-top:20px;">
                <el-button @click="close">关闭</el-button>
                <el-button  style="margin-left:20px;" type="primary" @click="onSaveDo">保存</el-button>
                <!-- <el-button style="margin-left:20px;" type="primary" @click="onNewPlan">新建后续计划</el-button> -->
            </div> 
            <el-divider  v-if="isDo" content-position="center">沟通提示</el-divider>
            <div  v-if="isDo">
                <span>
                    <p style="margin-left:20px;" v-if="planItem.remark" v-html="planItem.remark.replace('\r\n','\n').split('\n').map(item => `<p>${item}</p>`).join('')"></p>
                </span>
            </div>

            <el-divider content-position="center">跟进历史</el-divider>
            <el-timeline :reverse="reverse">
                <el-timeline-item v-for="(activity, index) in doLog" :key="index" :timestamp="activity.dealDate">
                    <!-- {{activity.dealContent}} -->
                    <div><i class="el-icon-caret-right"></i>服务内容</div>
                    <p style="margin-left:0px;margin-left:10px;" v-if="activity.dealContent" v-html="activity.dealContent.replace('\r\n','\n').split('\n').map(item => `<p>${item}</p>`).join('')"></p>
                    <div style="margin-top:20px;"><i class="el-icon-caret-right"></i>服务结论</div>
                    <p style="margin-left:0px;margin-left:10px;"
                     v-if="activity.dealResult" v-html="activity.dealResult.replace('\r\n','\n').split('\n').map(item => `<p>${item}</p>`).join('')"></p>
                    
                    <div style="display:flex" v-for="(sample, indexs) in activity.sampleArr" :key="indexs">
                        <el-link type="primary" :href="sample.url" target="_blank">{{sample.name}}</el-link>
                    </div>

                    <div v-if="activity.innerRemark"><i class="el-icon-caret-right"></i>内部说明</div>
                    <p style="margin-left:0px;margin-left:10px;color: red;" v-if="activity.innerRemark" v-html="activity.innerRemark.replace('\r\n','\n').split('\n').map(item => `<p>${item}</p>`).join('')"></p>
                    
                    <!-- <my-upload-file-form-item v-model="activity.sampleArr" label="附件" :limit="10" /> -->
                </el-timeline-item>
            </el-timeline>
            
            <div  v-if="!isDo">
                <el-form :model="viewform" inline  style="padding-left:8px;margin-top:-20px;">
                    <el-row  type="flex" style="margin-top:15px;" align="center">
                        <el-form-item label="结案时间">
                            {{planItem.finishTime}}
                        </el-form-item>
                        
                    </el-row>
                    <el-row v-if="planItem.seg=='Renew'">
                        <el-form-item label="续约结论">
                            {{planItem.renewType}}
                        </el-form-item>
                    </el-row>
                    <el-row v-if="planItem.seg=='Renew' && planItem.renewResultId=='55'">
                        <el-form-item label="不续费原因">
                            {{planItem.unRenewReason}}
                        </el-form-item>
                    </el-row>
                    <el-row  type="flex" style="margin-top:15px;" align="center">
                        <el-form-item label="结案说明">
                            {{planItem.finishDescript}}
                        </el-form-item>                                
                    </el-row>
                </el-form>
                <div slot="footer" style="display:flex;justify-content:center;margin-top:20px;">
                    <el-button @click="close">关闭</el-button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {ZC_FinishPlan} from "@/api/zc";
import { getToken } from "@/utils/auth";
import {getSampleArrayFromSever,getSampleLogStrToSever} from "@/utils/tools";
import {ZC_SaveResult} from "@/api/zc";

export default {
    name: 'baseform',
    props: ['planItem','isDo'],
    components: {
        MyUploadFileFormItem
      },
    computed: {
        ...mapGetters(['resultList','provideList'])
    },
    data() {
        return {
            doForm:{
                dealDate:'',
                content:'',
                result:'',
                provideTypeArr:[],
                sampleArr:[],
                innerRemark:'',
            },
            doLog:[],
            reverse: false,
            viewform:{},
        };
    },

    async mounted() {
        // await this.$store.dispatch('zc/provideList');
        this.doLog=[];
        this.doForm.content='';
        this.doForm.result='';
        this.doForm.dealDate='';
        this.doForm.sampleArr=[];
        await this.$store.dispatch('zc/resultList',{planId:this.planItem.id}).then(()=>{
            this.resultList.forEach(ele=>{
                var obj={};
                var samples = ele.samples;
                obj=ele;
                obj.sampleArr=getSampleArrayFromSever({samples});
                this.doLog.push(obj);
            })
        });     
       
    },


    methods: {
        close(){
            this.$emit('close');
        },

        async onSaveDo(){
            const {dealDate,content,result,sampleArr,provideTypeArr,innerRemark} = this.doForm;     
            
            if (!dealDate){
                this.$message.warning('选择服务时间')
                return;
            }
            var dDate = new Date(dealDate+'').toLocaleDateString();
            var h=dealDate.getHours();
            var m=dealDate.getMinutes();
            var s=dealDate.getSeconds();
            if (h<10){
                h='0'+h;
            }
            if (m<10){
                m='0'+m;
            }
            if (s<10){
                s='0'+s;
            }
            dDate = dDate + ' '+h+':'+m+':'+s
            console.log('this.doForm',dDate)

            if (!content){
                this.$message.warning('请填写服务内容')
                return;
            }
            var provideTypeIds='';
            if (provideTypeArr.length>0){
                provideTypeIds=provideTypeArr.join(',');
            }

            var samples = getSampleLogStrToSever({sampleArr})
            // console.log('aa',sampleArr,samples)   id,planId,dealDate,dealContent,samples
            await ZC_SaveResult({id:'',planId:this.planItem.id,dealDate:dDate,dealContent:content,dealResult:result,samples,provideTypeIds,innerRemark});
            this.$message.success('保存成功');
            this.$emit("onHaveDone");

        },
        
    }
};
</script>

<style scoped>
.order-detail >>> .el-form-item {
    margin-bottom: 2px;
}

</style>